import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useMediaQuery } from 'react-responsive'
import { reduxForm, Field } from "redux-form";

import { sendLoginCredentials, updateLoginCredentials } from "../../store/actions";
import PlaceholderImage from "../../sharedComponents/placeholderImage";
import Logo from "../../assets/images/logo-color.png";
import { FormField } from "../../sharedComponents/formField";
import { required, email } from "../../constants/formValidators";
import SubscribeNewsletter from "./subscribeToNewsletter";

import "./Session.scss";

const SignIn = ({ history, handleSubmit, sendLoginCredentials, updateLoginCredentials }) => {
	const [error, setError] = useState(null);

	const isDesktop = useMediaQuery({ query: '(min-width: 992px)' });
	
	const submitLogin = (values) => {
		const successHandler = (event) => {
			event.json().then((data) => {
				localStorage.setItem("MEDIWEIGHTLOSS_USER_DATA", JSON.stringify(data));
				updateLoginCredentials(data, () => history.push("/home"));
			});
		};
		const errorHandler = (event) => {
			setError(event && event.non_field_errors ? event.non_field_errors[0] : "Something went wrong. Please try later!");
		};
		sendLoginCredentials(values, successHandler, errorHandler);
	};

	const [show, setShow] = useState(false);

	return (
		<section className="page page-session">
			<div className="session-wrap">
				{isDesktop ? (
					<div className="session-left">
						<div className="left-data-container">
							<h2 className="normal">Membership with benefits!</h2>
							<p>Access is FREE for active Medi-Weightloss® patients and includes:</p>
							<ul className="check-list">
								<li>Your weight statistics and progress</li>
								<li>Food and supplement journal</li>
								<li>Approved recipes</li>
								<li>Exercise plans and tracker </li>
								<li>Customizable profile</li>
								<li>Appointment reminder</li>
								<li>Articles, information, tips, and more!</li>
							</ul>
						</div>
					</div>) : null}
				<div className="session-right">
					<PlaceholderImage src={Logo} />
					{!show ? <React.Fragment>
						<h3 className="text-center text-primary-dark mt-4 mb-3">Already a member?</h3>
						<form className="m-0" onSubmit={handleSubmit(submitLogin)}>
							<Field
								label="Email address"
								name="email"
								formGroupClass="no-label"
								type="text"
								component={FormField}
								validate={[required, email]}
								onFocus={() => setError(null)}
							/>
							<Field
								label="Password"
								name="password"
								type="password"
								formGroupClass="no-label"
								component={FormField}
								validate={[required]}
								onFocus={() => setError(null)}
							/>
							<button type="submit" className="w-100 btn btn-primary btn-lg text-uppercase">
								Login
						</button>
							{error && <div className="error small text-danger text-center mt-3">{error}</div>}
						</form>
						<div className="text-right mt-2 mb-4">
                            <Link to="/forgot-password" className="text-secondary">
                                Forgot your password?
                            </Link>
						</div>
						<h4 className="text-center text-primary-dark mb-3">
                            Need Help?{" "}
                            <a className="text-primary-dark" href="https://www.startmedi.com/spw-tutorial/" target="_blank" rel="noopener noreferrer">
                                Click Here
                            </a>
						</h4>
						<h4 className="text-center text-primary-dark mb-3">
							Need an account?{" "}
							<Link className="text-primary-dark" to="/register">
								Register Now
						    </Link>
						</h4>
					</React.Fragment> : <SubscribeNewsletter setShow={setShow} />}
				</div>
			</div>
		</section>
	);
};

const mapDispatchToProps = {
	sendLoginCredentials,
	updateLoginCredentials
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "SignInForm"
	})(SignIn)
);
